/* eslint-disable import/prefer-default-export */
const GO_HOME = 'home/GO';

export { GO_HOME };

/* eslint-enable import/prefer-default-export */



// WEBPACK FOOTER //
// ./src/store/actions/home.types.js